import React, {createContext, useReducer} from 'react'
import {FiltersStateReducer} from "../reducer/FiltersStateReducer";

export const FiltersStateContext = createContext();

/**
 * Context for state of common filters for different components
 * @param props 
 */
const FiltersStateContextProvider = (props) => {

    const [selectedFilterValues, dispatch] = useReducer(FiltersStateReducer, props.context ? JSON.parse(props.context.replaceAll('%2f', '/')) :
    {"cycles" : [], "CPT" : []});
    return (
        <FiltersStateContext.Provider value = {{selectedFilterValues, dispatch}}>
            {props.children}
        </FiltersStateContext.Provider>
    )
}

export default FiltersStateContextProvider;


// WEBPACK FOOTER //
// ./src/commons/context/FiltersStateContext.js